import { Popconfirm } from "antd";
import Avvvatars from "avvvatars-react";
import React from "react";
import { Link } from "react-router-dom";

interface EtudiantCardProps {
  etudiant: any;
  onDeletePhoto: (e: React.MouseEvent) => void;
  onAddPhoto: (e: React.MouseEvent) => void;
}

const StudentCard: React.FC<EtudiantCardProps> = ({
  etudiant,
  onDeletePhoto,
  onAddPhoto,
}) => {
  const photoUrl = etudiant.avatar?.temporaryUrl;

  return (
    <div className="etudiant-card">
      <div className="etudiant-photo-container">
        {etudiant.avatar?.temporaryUrl ? (
          <img
            src={photoUrl}
            alt={`${etudiant?.lastname} ${etudiant?.firstname}`}
            className="etudiant-photo"
          />
        ) : (
          <Avvvatars
            value={`${
              etudiant?.firstname?.charAt(0) || ""
            }${etudiant?.lastname?.charAt(0) || ""}`}
            style="character"
            size={80}
          />
        )}
        <div className="photo-overlay">
          {etudiant.avatar?.temporaryUrl && (
            <Popconfirm
              title="Êtes-vous sûr de vouloir supprimer cette photo ?"
              onConfirm={() => onDeletePhoto(etudiant?.id)}
              okText="Oui"
              cancelText="Non"
            >
              <button
                className="photo-action-btn delete"
                // onClick={onDeletePhoto}
                title="Supprimer la photo"
              >
                ✕
              </button>
              {/*<Button icon={<DeleteOutlined />} danger />*/}
            </Popconfirm>
          )}
          <button
            className="photo-action-btn add"
            onClick={onAddPhoto}
            title="Ajouter une photo"
          >
            ➕
          </button>
        </div>
      </div>
      <div className="etudiant-info">
        <div>
          <Link className="etudiant-name" to={`/student-detail/${etudiant.id}`}>
            {etudiant?.lastname} {etudiant?.firstname}
          </Link>

          {etudiant?.Registrations[0].Class?.label && (
            <span className="etudiant-classe-badge">
              {etudiant?.Registrations[0]?.Class?.Level?.abbreviation}-
              {etudiant?.Registrations[0]?.Class?.label}
            </span>
          )}
        </div>
        <div className="etudiant-classe">{etudiant?.matricule}</div>
      </div>
    </div>
  );
};

export default StudentCard;
